module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "data-animsition-in": "fade-in",
      "data-animsition-out": "fade-out"
    }
  }, [_c('div', {
    staticClass: "register-login"
  }, [_c('div', {
    staticClass: "big-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mt-100"
  }, [_c('div', {
    staticClass: "col-3 left-container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner-item"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("register.to_rent")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-item"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("register.cash_out")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "inner-item"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("register.to_like")) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "p-t-20 p-b-20 main-container"
  }, [_c('div', {
    staticClass: "container-inner"
  }, [_c('div', {
    staticClass: "row bg-cover container-inner-title-item"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-inner bg-cover"
  }, [_c('div', {
    staticClass: "title-inner"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("password_reset.title")) + "\n                      ")])])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit_reset(_vm.user)
      }
    }
  }, [_c('div', {
    staticClass: "row bg-cover container-inner-item"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-inner bg-cover"
  }, [_c('h2', {
    staticClass: "input-label"
  }, [_vm._v(_vm._s(_vm.$t('input.new_password')))]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "placeholder": _vm.$t('input.your_password'),
      "failed-validation-message": "Votre mot de passe doit comporter au moins 8 caractères et contenir au moins un chiffre, une lettre minuscule, une lettre majuscule et un caractère spécial.",
      "validation-regex": "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
      "required": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row bg-cover container-inner-item"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-inner bg-cover"
  }, [_c('h2', {
    staticClass: "input-label"
  }, [_vm._v(_vm._s(_vm.$t('input.confirm_new_password')))]), _vm._v(" "), _c('v-input-password', {
    attrs: {
      "classes": "form-control input-item",
      "error-classes": "text-xs leading-tight text-red-500",
      "placeholder": _vm.$t('input.confirm_password'),
      "required": ""
    },
    model: {
      value: (_vm.user.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.user, "password_confirmation", $$v)
      },
      expression: "user.password_confirmation"
    }
  })], 1)])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row bg-cover container-inner-item"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-inner bg-cover"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn_save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-align-center"
  }, [_c('div', {
    staticClass: "already-have-account"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('register.have_you_account')))]), _vm._v(" "), _c('p', {
    staticClass: "to-login"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login.index'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login.title')))])], 1)])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row p-t-20 p-b-20"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "superhote-logo"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "static/material/iconbar/assets/images/superhote__logo.svg",
      "alt": "SuperHote logo"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa58b26"}!./src/app/pages/password/reset/reset.html
// module id = 1337
// module chunks = 0